import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ClaimedBusinessProfile from './components/ClaimedBusinessProfile'
import api from 'api'
// import GradientCircularProgress from 'components/Common/GradientCircularProgress'
import { styled } from '@mui/material/styles'
import routes from 'routes'
import { useNavigate } from 'react-router-dom'
import Dialog from 'components/Common/Dialog'
import Button from 'components/Common/Button'
import { SECONDARY_BUTTON } from 'themes/theme'
import I18n from 'i18next';

import './styles.css'
import UnclaimedUser from './components/UnclaimedUser'

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  padding: '40px 35px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}))

// const ProfileCompletedProgress = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   flexDirection: 'row',
//   alignItems: 'center',
// }))

function BusinessProfileCard() {
  const [businessData, setBusinessData] = useState({})
  const [businessProfileCompletion, setBusinessProfileCompletion] = useState(0)
  const [userProfileCompletion, setUserProfileCompletion] = useState(0)
  const user = useSelector(state => state.userReducer.user)
  const [isDialogOpen, setIsDialogOpen] = useState({ profile: false, business: false })
  const navigate = useNavigate()

  const setDialog = useCallback(value => setIsDialogOpen(value), [setIsDialogOpen])

  useEffect(() => {
    if (!user) return
    fetchAndSetData()
  }, [user])

  const onClickMyAccount = () => {
    navigate(routes.myAccount)
  }

  const onClickMyBusiness = () => {
    navigate(routes.myBusiness)
  }

  const fetchAndSetData = async () => {
    const data = await api.getDashboardInfo()
    if (data?.business_info?.business_profile_completion)
      setBusinessProfileCompletion(parseInt(data?.business_info?.business_profile_completion))
    if (data?.user_info?.profile_completion) setUserProfileCompletion(parseInt(data?.user_info?.profile_completion))

    if (data.business_info?.claimed_business_details) {
      setBusinessData(data.business_info?.claimed_business_details)
      return
    }
  }

  return (
    <>
      <ProfileCardContainer>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '250px',
          }}
        >
          {businessData?.isClaimed ? (
            <ClaimedBusinessProfile
              businessData={businessData}
              userProfileCompletion={userProfileCompletion}
              businessProfileCompletion={businessProfileCompletion}
            />
          ) : (
            <UnclaimedUser
              businessData={businessData}
              userProfileCompletion={userProfileCompletion}
              businessProfileCompletion={businessProfileCompletion}
            />
          )}
        </Box>
        {/* <ProfileCompletedProgress>
          <GradientCircularProgress
            value={businessProfileCompletion}
            title={(I18n.t('header.claimedBusiness')).toUpperCase()}
            size="large"
            style={{ marginRight: '30px' }}
            onClick={() => {
              setDialog({ ...isDialogOpen, business: true })
            }}
          />
          <GradientCircularProgress
            value={userProfileCompletion}
            size="large"
            sx={{ marginLeft: '30px' }}
            title={I18n.t('homePage.userProfile')}
            onClick={() => {
              setDialog({ ...isDialogOpen, profile: true })
            }}
          />
        </ProfileCompletedProgress> */}
        {isDialogOpen.profile && (
          <Dialog
            show={isDialogOpen}
            setShow={() => setDialog({ ...isDialogOpen, profile: false })}
            title={I18n.t('homePage.increaseYourUserProfilePercentage')}
            content={
              <Box>
                <Typography variant="body1" color="primary">
                  {I18n.t('homePage.theFollowingItems')}
                </Typography>
                <ul className="percentage-dialog" style={{ marginTop: '30px' }}>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.firstAndLastName')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.businessTitle')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.address')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.profilePicture')}
                    </Typography>
                  </li>
                </ul>
                {/* <Typography variant="body2M" color="primary">
                  <NavLink onClick={onClickMyAccount} underline="hover">
                    <Typography variant="body2B" color="secondary">
                      Click here
                    </Typography>
                  </NavLink>{' '}
                  to access the My Profile pages.
                </Typography> */}
                <Box marginTop="50px">
                  <Button
                    type={SECONDARY_BUTTON}
                    sx={{ width: '260px', marginRight: '20px' }}
                    onClick={() => {
                      setIsDialogOpen(false)
                    }}
                  >
                    Close
                  </Button>
                  <Button sx={{ width: '260px' }} onClick={onClickMyAccount}>
                    Update User Profile
                  </Button>
                </Box>
              </Box>
            }
          />
        )}
        {/* {isDialogOpen.profile && (
          <Dialog
            className="percentage-dialog"
            title={
              <ModalTitle
                title="Increase Your User Profile Percentage"
                onClose={() => setDialog({ ...isDialogOpen, profile: false })}
              ></ModalTitle>
            }
            onClose={() => setDialog({ ...isDialogOpen, profile: false })}
          >
            <p className="text-lg color-primary">The following items are used to calculate completion:</p>
            <ul>
              <li className="text-lg color-primary">First and last name</li>
              <li className="text-lg color-primary">Business title</li>
              <li className="text-lg color-primary">Address (all four fields)</li>
              <li className="text-lg color-primary">Profile picture</li>
            </ul>
            <p className="text-normal color-primary">
              <NavLink onClick={onClickMyAccount}>Click here </NavLink>
              to access the My Profile pages.
            </p>
          </Dialog>
        )} */}
        {isDialogOpen.business && (
          <Dialog
            show={isDialogOpen}
            setShow={() => setDialog({ ...isDialogOpen, business: false })}
            title={I18n.t('homePage.increaseYourClaimedBusinessPercentage')}
            content={
              <Box>
                <Typography variant="body1" color="primary">
                  {I18n.t('homePage.theFollowingItems')}
                </Typography>
                <ul className="percentage-dialog" style={{ marginTop: '30px' }}>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.updateTheProfileTab')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.linkSocialMediaAccount')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.enterBusinessData')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.uploadYourBusinessLogo')}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" color="primary">
                      {I18n.t('homePage.addOnePerson')}
                    </Typography>
                  </li>
                </ul>
                {/* <Typography variant="body2M" color="primary">
                  <NavLink onClick={onClickMyBusiness} underline="hover">
                    <Typography variant="body2B" color="secondary">
                      Click here
                    </Typography>
                  </NavLink>{' '}
                  to access the My Profile pages.
                </Typography> */}
                <Box marginTop="50px">
                  <Button
                    type={SECONDARY_BUTTON}
                    sx={{ width: '285px', marginRight: '20px' }}
                    onClick={() => {
                      setIsDialogOpen(false)
                    }}
                  >
                    Close
                  </Button>
                  <Button sx={{ width: '285px' }} onClick={onClickMyBusiness}>
                    Update Claimed Business
                  </Button>
                </Box>
              </Box>
            }
          />
        )}
        {/* {isDialogOpen.business && (
          <Dialog
            className="percentage-dialog"
            title={
              <ModalTitle
                title="Increase Your Claimed Business Percentage"
                onClose={() => setDialog({ ...isDialogOpen, business: false })}
              ></ModalTitle>
            }
            onClose={() => setDialog({ ...isDialogOpen, business: false })}
          >
            <p className="text-lg color-primary">The following items are used to calculate completion:</p>
            <ul>
              <li className="text-lg color-primary">Update the Profile tab</li>
              <li className="text-lg color-primary">
                Link a Social Media account (Facebook, Twitter, LinkedIn or Instagram)
              </li>
              <li className="text-lg color-primary">Enter key business data on the Info tab</li>
              <li className="text-lg color-primary">Upload your business logo</li>
              <li className="text-lg color-primary">
                Add one person to the Key People tab (typically the owner/co-owners)
              </li>
            </ul>

            <p className="text-normal color-primary">
              <NavLink onClick={onClickMyBusiness}>Click here </NavLink>
              to access the Claimed Business pages.
            </p>
          </Dialog>
        )} */}
      </ProfileCardContainer>
    </>
  )
}

export default React.memo(BusinessProfileCard)
